<template>
  <div class="tag-anchor" :style="styles" :id="$attrs._id">
    <div class="tag-anchor__pos" :class="[`tag-anchor__pos--tail-${tailPosition}`, { 'tag-anchor__pos--highlight' : $attrs.isHighlighted }]">
      <div 
        class="tag-basic"
        :class="[ `tag-basic--tail-${tailPosition}`, {'tag-basic--highlight' : $attrs.isHighlighted }]"
        ref="el"
        v-html="label[lang]"
      >
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: ['pos', 'label', 'type', 'tail-position', 'lang'],

  computed: {
    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.tag-anchor {
  font-size: 1em;
  position: absolute;
  pointer-events: none;
  z-index: 5;

  &__pos {
    height: 0;
    width: 0;

    &--tail-top-left:after,
    &--tail-top-center:after,
    &--tail-top-right:after {
      @include tail3($basecolor)
    }

    &--tail-bottom-left:after,
    &--tail-bottom-center:after,
    &--tail-bottom-right:after {
      @include tail3($basecolor)
    }

    &--tail-left-center:after {
      @include tail3($basecolor)
    }

    &--tail-right-center:after {
      @include tail3($basecolor)
    }

    // &--tail-top-left:before,
    // &--tail-top-center:before,
    // &--tail-top-right:before {
    //   background: $basic-tag-bg-color;
    //   box-shadow: $tag-box-shadow;
    //   content: '';
    //   height: 3rem;
    //   left: 0;
    //   position: absolute;
    //   top: 0;
    //   transform: translateX(-50%);
    //   width: .25rem;
    // }

    // &--tail-bottom-left:before,
    // &--tail-bottom-center:before,
    // &--tail-bottom-right:before {
    //   background: $basic-tag-bg-color;
    //   bottom: 0;
    //   box-shadow: $tag-box-shadow;
    //   content: '';
    //   height: 3rem;
    //   left: 0;
    //   position: absolute;
    //   transform: translateX(-50%);
    //   width: .25rem;
    // }

    // &--tail-left-center:before {
    //   background: $basic-tag-bg-color;
    //   bottom: -50%;
    //   box-shadow: $tag-box-shadow;
    //   content: '';
    //   height: .25rem;
    //   left: 0;
    //   position: absolute;
    //   transform: translateY(50%);
    //   width: 3rem;
    // }

    // &--tail-right-center:before {
    //   background: $basic-tag-bg-color;
    //   bottom: -50%;
    //   box-shadow: $tag-box-shadow;
    //   content: '';
    //   height: .25rem;
    //   right: 0;
    //   position: absolute;
    //   transform: translateY(50%);
    //   width: 3rem;
    // }

    &--highlight {
      &::after,
      &::before {
        background-color: $basic-tag-highlight-color;
      }
    }
  }
}

.tag-basic {
  // background-color: $basic-tag-bg-color;
  // border-radius: $basic-tag-border-radius;
  // box-shadow: $tag-box-shadow;
  color: $basic-tag-font-color;
  font-family: $touchscreen-font;
  font-size: $basic-tag-font-size;
  font-weight: 400;
  letter-spacing: .1em;
  line-height: 1.1;
  width: max-content;
  padding: 0;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-shadow: $basic-tag-text-shadow;
  text-transform: uppercase;
  user-select: none;

  &--highlight {
    font-size: .75em;
    line-height: 1;
  }

  &--tail-top-left {
    left: 1em / $basic-tag-font-size + em;
    text-align: left;
    transform: translateY(-0.25rem);
  }

  &--tail-top-center {
    left: 50%;
    top: 1em / $basic-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-top-right {
    right: 1em / $basic-tag-font-size + em;
    text-align: right;
    transform: translateY(-0.25rem);
  }

  &--tail-bottom-left {
    bottom: .75em / $basic-tag-font-size + em;
    left: -$basic-tag-font-size;
    text-align: left;
  }

  &--tail-bottom-center {
    bottom: .75em / $basic-tag-font-size + em;
    left: 50%;
    transform: translateX(-50%);
  }

  &--tail-bottom-right {
    bottom: .75em / $basic-tag-font-size + em;
    right: -$basic-tag-font-size;
    text-align: right;
  }

  &--tail-left-center {
    left: 1em / $basic-tag-font-size + em;
    text-align: left;
    transform: translateY(-50%);
  }

  &--tail-right-center {
    right: 1em / $basic-tag-font-size + em;
    text-align: right;
    transform: translateY(-50%);
  }
}
</style>
